export const profileFields = [
  'type', 'region', 'area', 'total', 'price', 'buy_type', 'income', 'manager',
  'industry', 'job', 'job_time', 'buy_house', 'financial', 'introduce',
  'total_budget_range', 'price_acceptance_level', 'purpose_v2'
]
export function emptyProfileValue(value) {
  return value === '' || value === null || value === undefined || (Array.isArray(value) && !value.length)
}
export function sameProfileValue(left, right) {
  if (emptyProfileValue(left) && emptyProfileValue(right)) return true
  if (Array.isArray(left) || Array.isArray(right)) {
    return Array.isArray(left) && Array.isArray(right) && JSON.stringify(left.map(String).sort()) === JSON.stringify(right.map(String).sort())
  }
  return !emptyProfileValue(left) && !emptyProfileValue(right) && String(left) === String(right)
}
export function profileRows(result, values = {}, choices = {}, onlyFields = null) {
  const rows = []
  const seen = {}
  const updates = Array.isArray(result.profile_updates) ? result.profile_updates : []
  updates.forEach(update => {
    const field = update && update.field
    if (profileFields.indexOf(field) < 0 || seen[field] || (onlyFields && onlyFields.indexOf(field) < 0)) return
    const catalogue = (result.profile_options || {})[field] || {}
    const config = Object.prototype.hasOwnProperty.call(choices, field) ? choices[field] : catalogue
    const options = Array.isArray(config.options) ? config.options : []
    const value = profileValue(field, update.value, options)
    if (value === null) return
    const selectedValues = Array.isArray(value) ? value : [value]
    const valueLabel = options.filter(item => selectedValues.indexOf(Number(item.value)) >= 0).map(item => item.label).join('、')
    if (update.value_label && valueLabel !== update.value_label) return
    const quotes = (Array.isArray(update.quotes) ? update.quotes : []).filter(reference => {
      if (!reference || typeof reference.quote !== 'string' || reference.quote.trim().length < 2) return false
      return (result.sources || []).some(source => source.id === reference.source && source.text.indexOf(reference.quote) >= 0)
    })
    if (!quotes.length) return
    const current = Object.prototype.hasOwnProperty.call(values, field) ? values[field] : catalogue.current_value
    if (sameProfileValue(current, value)) return
    const currentValues = Array.isArray(current) ? current : [current]
    const currentLabel = options.filter(item => currentValues.some(v => sameProfileValue(item.value, v))).map(item => item.label).join('、')
    seen[field] = true
    rows.push({
      field, value, label: config.label || update.label, valueLabel,
      current, currentLabel: emptyProfileValue(current) ? '未填写' : currentLabel || '原值需核对',
      conflict: !emptyProfileValue(current), review: update.requires_confirmation || update.confidence !== 'high',
      reason: update.reason || '', quotes, evidence: quotes.map(reference => reference.source)
    })
  })
  return rows
}

export function profileValue(field, raw, options) {
  const multiple = field === 'total_budget_range'
  const values = multiple && Array.isArray(raw) ? raw : [raw]
  if (!values.length || values.length > (multiple ? 5 : 1)) return null
  const normalized = []
  for (let i = 0; i < values.length; i++) {
    const item = values[i]
    if (typeof item !== 'number' && !(typeof item === 'string' && /^\d+$/.test(item))) return null
    const value = Number(item)
    if (!Number.isInteger(value) || value <= 0 || normalized.indexOf(value) >= 0 || !options.some(option => Number(option.value) === value)) return null
    normalized.push(value)
  }
  normalized.sort((a, b) => a - b)
  return multiple ? normalized : normalized[0]
}



// WEBPACK FOOTER //
// ./src/common/ai-profile.js